import { Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Store } from '@ngxs/store';
import { catchError, finalize, of, tap } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { ButtonColors, ButtonTypes } from '@ed---interne/ng-uui-components';

import { Login } from '../../../core/states/auth.state';
import { emailValidator } from '../../../shared/validators/email.validator';
import { AuthMicrosoftService } from '../../../core/services/auth.microsoft.service';

@UntilDestroy()
@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false,
})
export class LoginComponent {
    public ButtonTypes = ButtonTypes;
    public ButtonColors = ButtonColors;
    public loading = false;

    constructor(
        private store: Store,
        private readonly formBuilder: FormBuilder,
        private authMicrosoft: AuthMicrosoftService,
    ) {}

    public loginFormGroup = this.formBuilder.group({
        email: ['', [emailValidator()]],
        password: [''],
    });

    public get isMicrosoftActivated(): boolean {
        return this.authMicrosoft.isActivated;
    }

    public loginWithMicrosoft() {
        this.authMicrosoft.login(); // redirige vers Microsoft, reviendra sur /azure-callback
    }

    public async login() {
        this.loading = true;

        this.store
            .dispatch(
                new Login({
                    email: this.loginFormGroup.value.email || '',
                    password: this.loginFormGroup.value.password || '',
                }),
            )
            .pipe(
                tap(() => {}),
                catchError((error) => {
                    console.error('Erreur lors de la connexion:', error);
                    return of(null);
                }),
                finalize(() => {
                    this.loading = false;
                }),
                untilDestroyed(this),
            )
            .subscribe();
    }
}
